<template>

   <div>

      <link rel="stylesheet" href="https://api.systempay.fr/static/js/krypton-client/V4.0/ext/classic-reset.css">
      
      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <b-tabs>

         <b-tab id="chapter1" active>
            <template slot="title">
               <big><i class="icon-list"></i> {{ $t('titles.synthesis') }}</big>
            </template>

            <v-card v-model="level.dialogValues.dialogShow" data-app="true" >

               <CardUpdatableHeader :row="row" :level="level"/>

               <ddoAlert :errors="level.errors"/>

               <v-card-text>

                  <v-container>

                     <v-row>
                        <h2>{{ $t('subtitles.identity') }}</h2>
                     </v-row>

                     <v-row>
                        <v-col cols="12" sm="6">
                           <v-text-field 
                              v-model="row.cus_name" 
                              :disabled="level.dialogValues.form_disabled" 
                              outlined 
                              :label="$t('texts.cus_name')" 
                              :rules="level.dialogOptions.codeRules" 
                              required 
                              :hint="$t('hints.cus_name')" 
                              persistent-hint>
                           </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <v-text-field 
                              v-model="row.cus_siret" 
                              :disabled="level.dialogValues.form_disabled" 
                              :label="$t('texts.cus_siret')" 
                              :hint="$t('hints.cus_siret')" 
                           >
                           </v-text-field>
                           <v-text-field 
                              v-model="row.cus_vatnumber" 
                              :disabled="level.dialogValues.form_disabled" 
                              :label="$t('texts.cus_vatnumber')" 
                              :hint="$t('hints.cus_vatnumber')" 
                           >
                           </v-text-field>
                        </v-col>

                        <v-btn small class="primary" rounded :disabled="level.dialogValues.disable_update" @click="update_cus_row_with_identity(row)">{{ $t('buttons.update') }}</v-btn>

                     </v-row>

                     <v-row>
                        <h2>{{ $t('subtitles.contacts') }}</h2>
                     </v-row>

                     <v-row>
                        <h3>{{ $t('subtitles.ctc_general') }} <small v-if="row.ctc_pk_general!=null">(ID {{ row.ctc_pk_general}})</small></h3>
                     </v-row>

                     <v-row>
                        <v-col cols="6">
                           <TemplateContact name="ctc_general" ref="ctc_general" :row="row.ctc_general" :level="level" :errors="contacterrors.general_errors" :flags="contactflags.general">
                           </TemplateContact>
                        </v-col>
                     </v-row>

                     <v-row>
                        <v-col cols="6">
                        <h3>{{ $t('subtitles.ctc_billing') }} <small v-if="row.ctc_pk_invoicing!=null">(ID {{ row.ctc_pk_invoicing}})</small></h3><b-checkbox dense v-model="row.ctc_billing_same_as_general" v-on:change="change_billing_checkbox">{{ $t('texts.ctc_billing_same_as_general') }}</b-checkbox>
                           <TemplateContact v-show="!row.ctc_billing_same_as_general" name="ctc_billing" ref="ctc_billing" :row="row.ctc_billing" :level="level" :errors="contacterrors.billing_errors" :flags="contactflags.billing">
                           </TemplateContact>
                        </v-col>
                        <v-col cols="6">
                        <h3>{{ $t('subtitles.ctc_shipping') }} <small v-if="row.ctc_pk_shipping!=null">(ID {{ row.ctc_pk_shipping}})</small></h3>
                           <!--<b-checkbox v-model="row.ctc_shipping_same_as_billing" v-on:change="change_shipping_checkbox">{{ $t('texts.ctc_shipping_same_as_billing') }}</b-checkbox>-->
                           <b-checkbox v-model="row.ctc_shipping_same_as_general" v-on:change="change_shipping_checkbox">{{ $t('texts.ctc_shipping_same_as_general') }}</b-checkbox>
                           <TemplateContact v-show="!row.ctc_shipping_same_as_general" name="ctc_shipping" ref="ctc_shipping" :row="row.ctc_shipping" :level="level" :errors="contacterrors.shipping_errors" :flags="contactflags.shipping">
                           </TemplateContact>
                        </v-col>
                     </v-row>

                     <v-row>
                        <v-col v-if="!level.dialogValues.form_create" cols="12">
                           <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.cus_create,'long') }}<br/>
                           <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.cus_update,'long') }}
                        </v-col>
                     </v-row>

                  </v-container>
                  <small>*{{ $t('texts.requiredfield') }}</small>
               </v-card-text>

               <!--<CardUpdatableFooter :row="row" :level="level"/>-->

            </v-card>

         </b-tab>

         <b-tab id="chapter2">
            <template slot="title">
               <big><i class="icon-list"></i> {{ $t('titles.orders') }}</big>
            </template>

            <v-card data-app="true">

               <v-card-text>
                  <h4>{{ $t('subtitles.orders') }}</h4>
                  <v-row cols="auto">
                     <ddoClientList key="myCustomerOrders" ref="myCustomerOrders" :loading="loading" :level="levels[0]" 
                        :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
                        :customSlotNames="levels[0].customSlotNames"
                        @loading="refresh_loading"
                     >

                        <template v-slot:header="{ errors }">
                           <span></span>
                        </template>

                        <template slot="pro_name" slot-scope="props">
                           <span class="headline">{{ props.row.pro_name }}</span>
                        </template>

                        <template slot="ord_code" slot-scope="props">
                           <span class="headline">{{ props.row.ord_code }}</span>
                        </template>
                           
                        <template slot="ord_starts_at" slot-scope="props">
                           <span class="headline">{{ $api._d(props.row.ord_starts_at,'short') }}</span>
                        </template>

                        <template slot="ors_code" slot-scope="props">
                           <span class="headline">{{ props.row.ors_name }}</span>                           
                        </template>

                        <template slot="ord_total_price" slot-scope="props">
                           <span class="display-1">{{ $n(props.row.ord_total_price,'currency') }}</span><span class="headline"> {{ $t('utils._np') }} {{ props.row.per_tag_per }}</span>
                        </template>

                     </ddoClientList>

                  </v-row>
               </v-card-text>
            </v-card>

         </b-tab>

         <b-tab id="chapter3">
            <template slot="title">
               <big><i class="icon-list"></i> {{ $t('titles.invoices') }}</big>
            </template>

            <v-card data-app="true">

               <v-card-text>
                  <h4>{{ $t('subtitles.invoices') }}</h4>
                  <v-row cols="auto">
                     <ddoClientList key="myCustomerInvoices" ref="myCustomerInvoices" :loading="loading" :level="levels[1]" 
                        :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks"
                        :customSlotNames="levels[1].customSlotNames"
                        @loading="refresh_loading"
                     >
                        <template v-slot:header="{ errors }">
                           <span v-if="compute_totalDueAmount(due_rows_l2)>0">
                              <h5>{{ $t('texts.selected_amount') }} : {{ $n(compute_totalSelectedAmount(selected_rows_l2),'currency') }}</h5>
                              <h5>{{ $t('texts.due_amount') }} : {{ $n(compute_totalDueAmount(due_rows_l2),'currency') }}</h5>
                              {{ $t('texts.explanation_select_and_pay_invoices') }}<br/><br/>
                              <v-btn :disabled="compute_totalSelectedAmount(selected_rows_l2)<=0" class="warning" rounded @click="display_payment_invoices">{{ $t('buttons.pay_by_card') }}</v-btn>
                           </span>

                           <!-- The parameter "eager" is crucial : it permits to ddoSystemPay to be rendered (mounted) when "showPaymentDialog" becomes true -->
                           <v-dialog name="processPayment" v-model="showPaymentDialog" eager data-app="true" persistent width="400" max-width="900">
                              <ddoSystemPay
                                 ref="myPaymentInvoice" 
                                 @onPaid="onPaid"
                                 @onClose="onClose"
                              />
                           </v-dialog>

                        </template>

                        <template slot="inv_date" slot-scope="props">
                           <span class="headline">{{ $api._d(props.row.inv_date,'short') }}</span>
                        </template>

                        <template slot="inv_is_invoice" slot-scope="props">
                           <span class="headline" v-if="props.row.inv_is_invoice==true">{{ $t('texts.invoice') }}</span>
                           <span class="headline" v-else>{{ $t('texts.creditnote') }}</span>
                        </template>

                        <template slot="inv_code" slot-scope="props">
                           <span class="headline">{{ props.row.inv_code }}</span>
                        </template>
                           
                        <template slot="inv_bm_specific_fields" slot-scope="props">
                           <span v-if="props.row.inv_is_invoice">{{$t('utils._datefrom')}}{{ $api._d(props.row.inv_period_start,'short') }}{{$t('utils._dateto')}}{{ $api._d(props.row.inv_period_end,'short') }}</span>
                        </template>
                           
                        <template slot="ins_name" slot-scope="props">
                           <span class="headline">{{ props.row.ins_name }}</span>                           
                        </template>

                        <template slot="inv_signed_total_price" slot-scope="props">
                           <span class="display-1">{{ $n(props.row.inv_signed_total_price,'currency') }} {{ $t('utils._gp') }}</span>
                        </template>

                        <template slot="inv_pdf_link" slot-scope="props">
                           <span v-if="props.row.inv_pdf_link!=null"><a :href="$api.get_pdf_link(props.row.inv_pdf_link,$config)" target="_blank"><v-icon x-large color="red darken-2">mdi-file-pdf</v-icon></a></span>
                           <span v-else>NO LINK</span>
                        </template>

                     </ddoClientList>

                  </v-row>
               </v-card-text>
            </v-card>

         </b-tab>

      </b-tabs>

   </div>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import ddoSystemPay from '@/components/ddoSystemPay.vue';
import TemplateContact from '@/components/partials/TemplateContact.vue';

//import KRGlue from "@lyracom/embedded-form-glue";

export default {
   name: 'CardUpdatableCustomercustomer',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      ddoWaiting,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoClientList,
      TemplateContact,
      ddoSystemPay,
   },

   props: {
   },

   data: function () {
      return {
         show: false,
         loading: false,
         showPaymentDialog: false,

         contacterrors: { general_errors: [], billing_errors: [], shipping_errors: [] },
         contactflags: {
            general: {disable_update: true}, 
            billing: {disable_update: true}, 
            shipping: {disable_update: true}
         },

         selected_rows_l2: [],
         due_rows_l2: [],
         invoices_id_l2: [],
         invoices_code_l2: [],

         paymentScript: null,
         formToken: '',
         promiseError: '',

         levels: [
         {
            api_code: 'customer',
            api_prefix: 'cus',
            row: {},
            level: 0,
            errors: [],
            columns: [ 'ord_starts_at', 'pro_name', 'ord_code', 'ors_code', 'ord_total_price'],
            customSlotNames: ['ord_starts_at','pro_name','ord_code','ors_code','ord_total_price'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               hiddenColumns: [],
               headings: {
                  ord_starts_at: i18n.t('headers.code'),
                  pro_name: i18n.t('headers.pro_name'),
                  ord_code: i18n.t('headers.ord_code'),
                  ors_code: i18n.t('headers.ors_code'),
                  ord_total_price: i18n.t('headers.ord_total_price'),
               },
               texts: {
               },
               uniqueKey: 'ord_pk',
               columnsClasses: {
                  ord_total_price: 'text-right',
               },
               filterable: false,
               perPage: 50,
               perPageValues: [50,100,200],
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
         },
         {
            api_code: 'customer',
            api_prefix: 'cus',
            row: {},
            level: 1,
            errors: [],
            columns: [ 'inv_date', 'inv_is_invoice', 'inv_code', 'inv_bm_specific_fields', 'ins_name', 'inv_signed_total_price','inv_pdf_link'],
            customSlotNames: ['inv_date','inv_is_invoice','inv_code','inv_bm_specific_fields','ins_name','inv_signed_total_price','inv_pdf_link'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               hiddenColumns: [],
               headings: {
                  inv_date: i18n.t('headers.inv_date'),
                  inv_is_invoice: i18n.t('headers.inv_is_invoice'),
                  inv_code: i18n.t('headers.inv_code'),
                  ins_name: i18n.t('headers.ins_name'),
                  inv_pdf_link: i18n.t('headers._pdf_link'),
                  inv_bm_specific_fields: i18n.t('headers.inv_bm_specific_fields'),
                  inv_signed_total_price: i18n.t('headers.inv_signed_total_price'),
                  _update: i18n.t('headers.updated_on')
               },
               texts: {
               },
               selectable: {
                  mode: 'multiple', // or 'multiple'
                  only: function(row) {
                     return (row.ins_is_payable) // checkbox if invoice can be paid
                  },
                  selectAllMode: 'all', // or 'page',
                  programmatic: false
               },
               uniqueKey: 'inv_pk',
               columnsClasses: {
                  inv_signed_total_price: 'text-right',
               },
               columnsDisplay: {
                  _update: 'desktop',
                  inv_desc: 'desktop',
                  inv_pdf_link: 'desktop',
                  inv_is_invoice: 'desktop',
                  inv_bm_specific_fields: 'desktop',
               },
               rowClassCallback: function(row) {
                  if ( row.ins_is_payable==true ) {
                     return "row-not-paid";
                  } else {
                     return "row-paid";
                  }
               },
               filterable: false,
               perPage: 50,
               perPageValues: [50,100,200],
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
         },
         ]

      }
    },

   created() {
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;
      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.select_rows    = this.select_rows_l2;

      this.level.callbacks.update_ctc_row     = this.update_ctc_row;
   },

   methods: {

      async display_payment_invoices() {
         var infos = { cus_pk: this.row._pk, pay_price: this.compute_totalSelectedAmount(this.selected_rows_l2), pay_currency: 'EUR', pay_inv_pks: this.invoices_id_l2.join(',') }
         this.loading = true;
         var { errorinfos, api_response } = await this.$refs.myPaymentInvoice.display_payment(infos);
         this.loading = false;
         if ( api_response.error==0 ) {
            this.showPaymentDialog = true;
         } else {
            this.levels[1].errors = [errorinfos];
            this.$refs.myCustomerInvoices.errors = [errorinfos];
         }
      },

      onClose() {
         this.showPaymentDialog = false;
      },

      onPaid(event) {
         console.log('Paid , in Parent !');
         if (event.clientAnswer.orderStatus === "PAID") {
            //document.getElementById("paymentSuccessful").style.display = "block";
            this.showPaymentDialog = false;
         } else {
         }         
         this.showPaymentDialog = false;
      },

      compute_totalSelectedAmount(rows) {
         let total = 0.0;
         for ( var i=0;i<rows.length;i++) {
            total += parseFloat(rows[i].inv_signed_total_price);
         } 
         return total;
      },

      compute_totalDueAmount(rows) {
         let total = 0.0;
         for ( var i=0;i<rows.length;i++) {
            if ( rows[i].ins_is_payable ) {
               total += parseFloat(rows[i].inv_signed_total_price);
            }
         } 
         return total;
      },

      select_rows_l2(rows) {
         this.selected_rows_l2 = rows;
         this.invoices_id_l2 = [];
         for ( var i=0;i<rows.length;i++ ) {
            if ( rows[i].inv_pk ) {
               this.invoices_id_l2.push(rows[i].inv_pk);
               this.invoices_code_l2.push(rows[i].inv_code);
            }
         }
      },

      async refresh_rows_all(row) {
         if ( row._pk!==null) {
            if ( this.$refs.myCustomerOrders ) {
               await this.$refs.myCustomerOrders.refresh_rows(row._pk);
            }
            if ( this.$refs.myCustomerInvoices ) {
               await this.$refs.myCustomerInvoices.refresh_rows(row._pk);
            }
         }
      },

      async refresh_rows_l1(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+this.row._pk+'/orders');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+this.row._pk+'/invoices');
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            this.due_rows_l2 = api_response.rows;
         }
         return { errorinfos, api_response }
      },

      refresh_loading(value) {
         this.loading = value;
      },

      copy_contact_from_to(ctc_from,ctc_to) {
         ctc_to = JSON.parse(JSON.stringify(ctc_from));
         ctc_to.marker = 'billing';
      },

      change_billing_checkbox(value) {
         if ( value==true ) {
            this.update_cus_row_with_contacts(this.row.ctc_general,'billing');
         } else {
            this.copy_contact_from_to(this.row.ctc_general,this.row.ctc_billing);
            this.row.ctc_billing.ctc_pk = null;
         }
      },

      change_shipping_checkbox(value) {
         if ( value==true ) {
            this.update_cus_row_with_contacts(this.row.ctc_general,'shipping');
         } else {
            this.copy_contact_from_to(this.row.ctc_general,this.row.ctc_shipping);
            this.row.ctc_shipping.ctc_pk = null;
         }
      },

      async update_cus_row_with_contacts(row,marker) {
         if ( marker ) {
            switch (marker) {
               case 'general' :
                  this.row.ctc_pk_general = row.ctc_pk;
                  break;
               case 'billing' :
                  this.row.ctc_pk_invoicing = row.ctc_pk;
                  break;
               case 'shipping' :
                  this.row.ctc_pk_shipping = row.ctc_pk;
                  break;
            }
            this.loading = true;
            var { errorinfos, api_response } = await this.$api.updateRow( this.$router, 'customer', row.cus_pk, this.row, 'update_contact_'+marker );
            this.loading = false;
            this.level.errors = [errorinfos];
         }
      },

      async update_cus_row_with_identity(row) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.updateRow( this.$router, 'customer', row.cus_pk, row, 'update_identity' );
         this.loading = false;
         this.level.errors = [errorinfos];
      },

      /*
       * Update (or create) a Contact. 'row' is a copy of a ctc_* record.
       * We create/update it, and refresh the whole customer record.
       */
      async update_ctc_row(row) {
         //console.log('update_ctc_row, row='+JSON.stringify(row));
         this.contacterrors.general_errors  = [];
         this.contacterrors.billing_errors  = [];
         this.contacterrors.shipping_errors = [];

         this.loading = true;

         if ( row.ctc_pk!=null ) {
            var { errorinfos, api_response } = await this.$api.updateRow( this.$router, 'contact', row.ctc_pk, row, 'update_essentials' );
         } else {
            row.cus_pk = this.row.cus_pk;
            //console.log('update_ctc_row, create='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow( this.$router, 'contact', row );
            if ( api_response.error==0 && api_response._pk!=null ) {
               row.ctc_pk = api_response._pk;
            }
         }
         if ( errorinfos ) {
            switch(row.marker) {
               case 'general' :
                  this.contacterrors.general_errors  = [errorinfos];
                  break;
               case 'billing' :
                  this.contacterrors.billing_errors  = [errorinfos];
                  break;
               case 'shipping' :
                  this.contacterrors.shipping_errors  = [errorinfos];
                  break;
            }
            //console.log('update_ctc_row, after update, contacterrors='+JSON.stringify(this.contacterrors));
         }

         //console.log('update_ctc_row, api_response='+JSON.stringify(api_response));
         if ( api_response.error==0 ) {
            //console.log('update_ctc_row, api_response='+JSON.stringify(api_response));
            await this.update_cus_row_with_contacts(this.row,this.row.marker);
         }

         this.loading = false;

      },

      refresh_errors(level,errors) {
         //this.levels[level].errors = errors;
      },

   },
}
</script>

<style>
.KRcontainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.list-group-item {
  cursor: move;
}
input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}
input[type=checkbox]:disabled
{
    display:none;
    visibility:hidden;
}
.vt-select-row
{
  /* Checkbox text */
  font-size: 150%;
  display: inline;
}
.row-paid {
   background-color: rgb(204, 247, 204) !important;
}
.row-not-paid {
   background-color: rgb(245, 208, 208) !important;
}
</style>